<template>
	<v-breadcrumbs dark :items="crumbs" />
</template>

<script>
	export default {
		computed: {
			crumbs: function() {
				const pathArray = this.$route.path.split("/")
				pathArray.shift()
				// N-291 (6A): `/admin/presupuestos/<nº>` tiene un trozo más que rutas casadas (el nº es un
				// parámetro); una miga por ruta, o `matched[idx]` no existe y revientan.
				pathArray.splice(this.$route.matched.length)
				const breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
				breadcrumbArray.push({
					path: path,
					name: name,
					to: breadcrumbArray[idx - 1]
					? "/" + breadcrumbArray[idx - 1].path + "/" + path: "/" + path,
					text: this.$route.matched[idx].name || path,
				});
				return breadcrumbArray;
				}, [])
				return breadcrumbs;
			}
		}
	}
</script>

<style lang="scss">
	.v-breadcrumbs li:nth-child(-n+2) {
		display: none;
	}

	.v-breadcrumbs__item {
		text-transform: uppercase;
	}
</style>
